import ProfitLossHTMLPreviewBaseStrategy from './ProfitLossHTMLPreviewBaseStrategy'

export default function ProfitLossHTMLPreviewHideRatesStrategy () {}

ProfitLossHTMLPreviewHideRatesStrategy.prototype = new ProfitLossHTMLPreviewBaseStrategy();

ProfitLossHTMLPreviewHideRatesStrategy.prototype.init = function ( timeFormat, showSpentTime )
{
    ProfitLossHTMLPreviewBaseStrategy.prototype.init.call( this, timeFormat, showSpentTime );
    return this;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getBillableAmountColHeaderText = function ()
{
    return this.message("report.profit_loss.billable_amount.header") + " (" + SystemSettings.currencySign + ")";
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getCostOfWorkColHeaderText = function ()
{
    return this.message("report.profit_loss.cost.header") + " (" + SystemSettings.currencySign + ")";
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getBillableAmountColSpan = function ()
{
    return 1;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getBillableAmountRowSpan = function ()
{
    return 2;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getCostOfWorkColSpan = function ()
{
    return 1;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getCostOfWorkRowSpan = function ()
{
    return 2;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.addSecondHeaderRowCells = function ( secondHeaderRow )
{
    // do nothing
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.addDataCells = function ( row )
{
    if (this.showSpentTime)
        this.addTimeValueCell( row, "spent" );

    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row );
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getDataColumnsCount = function ()
{
    return this.showSpentTime ? 4 : 3;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewHideRatesStrategy.js